import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import MaterialDashboard from "./material-dashboard";



// 환경 변수에 따라 Axios 기본 URL 설정
// axios.defaults.baseURL = process.env.NODE_ENV === 'production'
//   ? 'https://admin.dongan1718.com:5050/api'
//   : 'http://127.0.0.1:5050';

  // axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  // ? 'https://admin.dongan1718.com:5050/api' // 운영 환경 URL
  // : 'http://localhost:5050'; // 개발 환경 URL

  createApp(App)
  .use(router)
  .use(store)
  .use(MaterialDashboard)  
  .mount("#app");